<template>
  <b-card>

    <!-- media -->
    <b-media
      no-body
      style="display: none;"
    >
      <b-media-aside>
        <b-link>
          <b-img
            ref="previewEl"
            rounded
            :src="optionsLocal.avatar"
            height="80"
          />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="$refs.refInputEl.$el.click()"
        >
          Upload
        </b-button>
        <b-form-file
          ref="refInputEl"
          v-model="profileFile"
          accept=".jpg, .png, .gif"
          :hidden="true"
          plain
          @input="inputImageRenderer"
        />
        <!--/ upload button -->

        <!-- reset -->
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          size="sm"
          class="mb-75 mr-75"
        >
          Reset
        </b-button>
        <!--/ reset -->
        <b-card-text>Allowed JPG, GIF or PNG. Max size of 800kB</b-card-text>
      </b-media-body>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form
        class="mt-2"
        @submit.prevent
      >
        <b-row>
          <b-col
            sm="6"
            style="display: none;"
          >
            <b-form-group
              label="Username"
              label-for="account-username"
            >
              <b-form-input
                v-model="optionsLocal.username"
                placeholder="Username"
                name="username"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="Name"
              label-for="account-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Employee"
              >
                <b-form-input
                  v-model="optionsLocal.name"
                  name="name"
                  placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="E-mail"
              label-for="account-e-mail"
            >
              <b-form-input
                v-model="optionsLocal.email"
                name="empl_address"
                placeholder="Email"
              />

            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="Phone"
              label-for="account-phone"
            >
              <b-form-input
                v-model="optionsLocal.phone"
                name="phone"
                placeholder="Phone"
              />

            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="Role"
              label-for="account-role"
            >
              <b-form-input
                v-model="optionsLocal.role"
                name="role"
                placeholder="Role name"
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- alert -->
          <b-col
            style="display:none"
            cols="12"
            class="mt-75"
          >
            <b-alert
              show
              variant="warning"
              class="mb-50"
            >
              <h4 class="alert-heading">
                Your empl_address is not confirmed. Please check your inbox.
              </h4>
              <div class="alert-body">
                <b-link class="alert-link">
                  Resend confirmation
                </b-link>
              </div>
            </b-alert>
          </b-col>
          <!--/ alert -->

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1"
              @click.prevent="validationForm"
            >
              Save changes
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              type="reset"
              class="mt-2"
              @click.prevent="resetForm"
            >
              Reset
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import avatarImg from '@/assets/images/portrait/small/avatar-s-11.jpg'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      required,
      optionsLocal: {
        avatar: avatarImg,
        name: 'johndoe',
        username: 'johndoe',
        empl_gender: 'F',
        empl_birth_place: 'Jakarta',
        empl_birth_date: '2006-01-02',
        empl_address: 'Jl.Raya No.4',
        phone: '',
        email: 'granger007@hogward.com',
        role: 'Crystal Technologies',
      },
      profileFile: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            const formData = this.optionsLocal
            this.$store.dispatch('profile/formPostPut', formData)
              .then(() => {
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
              },
              () => {
                this.show = false
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    resetForm() {
      // this.optionsLocal = {
      //   avatar: require('@/assets/images/portrait/small/avatar-s-11.jpg'),
      //   username: 'johndoe',
      //   empl_name: 'John Doe',
      //   empl_address: 'granger007@hogward.com',
      //   role: 'Crystal Technologies',
      // }
    },
    getData(id) {
      this.$store.dispatch('profile/getById', id).then(data => {
        this.optionsLocal.phone = data.phone
        this.optionsLocal.name = data.name
        this.optionsLocal.email = data.email
        this.optionsLocal.role = data.roles.name
        this.show = false
      })
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
